import { ReactElement } from 'react';

import { ChakraToolTip } from '@equip.health/ui';

interface PatientTableCellToolTipProps {
  children: ReactElement;
  content: string | ReactElement;
  hidden?: boolean;
  id: string;
}

const PatientTableCellToolTip = ({
  children,
  content,
  hidden,
  id,
}: PatientTableCellToolTipProps): ReactElement => (
  <ChakraToolTip
    bg="white"
    color="neutral.secondary"
    gutter={3}
    hasArrow
    hidden={!!hidden}
    id={`${id}__tooltip`}
    label={content}
  >
    {children}
  </ChakraToolTip>
);

export default PatientTableCellToolTip;
